module.exports = __webpack_public_path__ + "assets/img/icono-ubicacion.svg";